import { render, staticRenderFns } from "./googleAI25.vue?vue&type=template&id=01f5ac76&scoped=true&"
import script from "./googleAI25.vue?vue&type=script&lang=js&"
export * from "./googleAI25.vue?vue&type=script&lang=js&"
import style0 from "./googleAI25.vue?vue&type=style&index=0&id=01f5ac76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5ac76",
  null
  
)

export default component.exports